import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Container, Grid, Paper } from '@material-ui/core';

import styles from './styles';

const useStyles = makeStyles(theme => (styles));

const AboutView = () => {

  const classes = useStyles();

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item sm={8} style={{margin: 'auto'}}>
          <Paper className={classes.panel}>
            <Typography>
              <h3>About</h3>
              <p>
              This webpage allows for making volatility predictions using an adaption of the prediction methodology presented in Audrino, Sigrist, and Ballinari (2020) and Ballinar, Audrino, and Sigrist, and (2020).
              </p>

              <p>
              Logarithmic realized volatility is predicted using a predictive regression model obtained as an extension of the HAR model (Corsi, 2009). Daily realized volatility is estimated using the approach of Garman and Klass (1980).
              </p>

              <p>
              The user can choose to extend the HAR model by adding the following predictor variables:
              <ul>
                <li>VIX (Volatility Index) and volume</li>
                <li>Market-wide attention measures
                  <ul>
                    <li>Number of Google searches for "stock market"</li>
                    <li>Number of Google searches for "interest rates"</li>
                    <li>Number of Google searches for "financial market"</li>
                    <li>A combination of the above three variables denoted as "general attention"</li>
                  </ul>
                </li>
                <li>Stock-specific attention measure(s)
                  <ul>
                    <li>Number of Google searches for the stock ticker</li>
                  </ul>
                </li>
				<li>Earnings announcements dummy variables</li>
              </ul>
              </p>
            </Typography>
          </Paper>
          <Paper className={classes.panel}>
            <Typography>
            <h3>References</h3>
            <ul>
              <li>Audrino, F., Sigrist, F., & Ballinari, D. (2020). The impact of sentiment and attention measures on stock market volatility. International Journal of Forecasting, 36(2), 334-357</li>
			  <li>Ballinari, D., Audrino, F., & Sigrist, F. (2020). When does attention matter? The effect of investor attention on stock market volatility around news releases. Preprint available on https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3506720 </li>
              <li>Corsi, F. (2009). A simple approximate long-memory model of realized volatility. Journal of Financial Econometrics, 7(2), 174-196</li>
              <li>Garman, M. B., & Klass, M. J. (1980). On the estimation of security price volatilities from historical data. Journal of business, 67-78</li>
            </ul>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutView;
